import * as api from "api/vehicleImporterApi"
import {
  usePaginatedResource,
  useResourceItem,
  useCreateResource,
  useEditResource,
  useDeleteResource,
} from "./useCrudResource"

export const VEHICLE_IMPORTER_QUERY_KEYS = {
  VEHICLE_IMPORTER: "vehicleImporters",
}

// -------------------- VEHICLE IMPORTERS --------------------

// 🔹 Get paginated list
export const useVehicleImporters = (params, enabled = true) =>
  usePaginatedResource(
    VEHICLE_IMPORTER_QUERY_KEYS.VEHICLE_IMPORTER,
    api.getVehicleImporters,
    params,
    enabled
  )

// 🔹 Get paginated list of stocks for a specific importer
export const VEHICLE_IMPORTER_STOCKS_QUERY_KEY = `${VEHICLE_IMPORTER_QUERY_KEYS.VEHICLE_IMPORTER}-stocks`
export const useVehicleImporterStocks = (params, enabled = true) => {
  return usePaginatedResource(
    `${VEHICLE_IMPORTER_STOCKS_QUERY_KEY}-${params?.importerId}`,
    api.getVehicleImporterStocks,
    params,
    enabled
  )
}

// 🔹 Get paginated list of group stocks for a specific importer
export const useVehicleImporterGroupStocks = (params, enabled = true) => {
  return usePaginatedResource(
    `${VEHICLE_IMPORTER_QUERY_KEYS.VEHICLE_IMPORTER}-grouped-stocks-${params?.importerId}`,
    api.getVehicleImporterGroupStocks,
    params,
    enabled
  )
}

// 🔹 Get single importer by ID
export const useVehicleImporter = identifier =>
  useResourceItem(
    VEHICLE_IMPORTER_QUERY_KEYS.VEHICLE_IMPORTER,
    api.getVehicleImporter,
    identifier
  )

// 🔹 Create importer
export const useCreateVehicleImporter = () =>
  useCreateResource(api.createVehicleImporter, VEHICLE_IMPORTER_QUERY_KEYS.VEHICLE_IMPORTER)

// 🔹 Edit importer
export const useEditVehicleImporter = () =>
  useEditResource(api.editVehicleImporter, VEHICLE_IMPORTER_QUERY_KEYS.VEHICLE_IMPORTER)

// 🔹 Delete importer
export const useDeleteVehicleImporter = () =>
  useDeleteResource(api.deleteVehicleImporter, VEHICLE_IMPORTER_QUERY_KEYS.VEHICLE_IMPORTER)

// Vehicle Importer Stocks Sorting Parameters
export const STOCK_SORT_OPTIONS = {
  TITLE: "title",
  TITLE_DESC: "title_desc",
  TOTAL: "total",
  TOTAL_DESC: "total_desc",
}
